import CartAnalyticsClient from 'modules/analytics/CartAnalyticsClient';

const OMNICHANNEL_EVENT_OPTIONS = {
  source: 'ChannelCommunicationHub',
  target: 'Omnichannel',
} as const;

const INVOCATION_PLATFORM_OMNICHANNEL_CHAT = 'omnichannel-chat';

interface SendOperationalAnalyticsEventOptions {
  action: string;
  actionSubject: string;
  attributes?: Record<string, any>;
  source: string;
  target?: string;
}

const sendOperationalAnalyticsEvent = (options: SendOperationalAnalyticsEventOptions) => {
  const { action, actionSubject, attributes = {}, source, target } = options;
  const enrichedAttributes = {
    ...attributes,
    ...(target ? { target } : {}),
  };
  CartAnalyticsClient.getClient().sendOperationalEvent({
    source,
    action,
    actionSubject,
    attributes: enrichedAttributes,
  } as any);
};

interface CustomerJoinedConversationAttributes {
  conversationId: string;
}

interface CommunicationHubErrorAttributes {
  typeOfError: string;
  errorMessage?: string;
}

interface TokenGenerationSuccessAttributes {
  supportedChannels: string[];
}

interface ChatConnectionRefreshSuccessAttributes {
  conversations: number;
  allConversationIds: string;
  conversationId: string;
}

export const sendCustomerJoinedConversationOmnichannelEvent = (
  attributes: CustomerJoinedConversationAttributes,
) => {
  sendOperationalAnalyticsEvent({
    ...OMNICHANNEL_EVENT_OPTIONS,
    action: 'received',
    actionSubject: 'CustomerJoinedConversation',
    attributes: {
      ...attributes,
      invocation_platform: INVOCATION_PLATFORM_OMNICHANNEL_CHAT,
    },
  });
};

export const sendOmnichannelCommunicationHubErrorEvent = (
  attributes: CommunicationHubErrorAttributes,
) => {
  sendOperationalAnalyticsEvent({
    ...OMNICHANNEL_EVENT_OPTIONS,
    action: 'failed',
    actionSubject: 'ChatConnection',
    attributes,
  });
};

export const sendOmnichannelTokenGenerationSuccessEvent = (
  attributes: TokenGenerationSuccessAttributes,
) => {
  sendOperationalAnalyticsEvent({
    ...OMNICHANNEL_EVENT_OPTIONS,
    action: 'success',
    actionSubject: 'TokenGeneration',
    attributes,
  });
};

export const sendOmnichannelChatConnectionRefreshSuccessEvent = (
  attributes: ChatConnectionRefreshSuccessAttributes,
) => {
  sendOperationalAnalyticsEvent({
    ...OMNICHANNEL_EVENT_OPTIONS,
    action: 'success',
    actionSubject: 'ChatConnectionRefresh',
    attributes,
  });
};

export const sendCustomerConversationTabClosedOmnichannelEvent = (
  attributes?: Record<string, any>,
) => {
  sendOperationalAnalyticsEvent({
    ...OMNICHANNEL_EVENT_OPTIONS,
    action: 'closed',
    actionSubject: 'CustomerConversationTab',
    attributes: {
      ...(attributes || {}),
      invocation_platform: INVOCATION_PLATFORM_OMNICHANNEL_CHAT,
    },
  });
};

export const sendOmnichannelWidgetLoadedEvent = (attributes?: Record<string, any>) => {
  sendOperationalAnalyticsEvent({
    ...OMNICHANNEL_EVENT_OPTIONS,
    action: 'success',
    actionSubject: 'OmnichannelWidgetLoaded',
    attributes,
  });
};
